<script setup lang="ts">
import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import { isValidString } from "@/Utils/String";
import { computed } from "vue";

export interface TcLoaderProps {
  size?: number;
  center?: boolean;
  color?: colorTag;
}

const props = withDefaults(defineProps<TcLoaderProps>(), {
  size: 50,
  center: true,
  color: "content-high",
});

const degId = computed((): string => `loader_deg_${new Date().getTime()}`);

const colorClass = computed(() => (isValidString(props.color) ? `fill-${props.color}` : ""));
</script>

<template>
  <div class="loader" :class="{ 'loader--center': center }">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 24 24"
      class="rotate animation_infinite"
      :style="{ width: `${props.size}px`, height: `${props.size}px` }"
    >
      <defs>
        <linearGradient :id="degId" x1="18.16" y1="17.76" x2="8.62" y2="8.86" gradientUnits="userSpaceOnUse">
          <slot name="gradient">
            <stop offset=".12" stop-color="#fff" stop-opacity="0" />
            <stop offset=".2" stop-color="#d7d7f3" stop-opacity=".26" />
            <stop offset=".28" stop-color="#b4b5ea" stop-opacity=".48" />
            <stop offset=".36" stop-color="#9799e2" stop-opacity=".67" />
            <stop offset=".44" stop-color="#8083dc" stop-opacity=".81" />
            <stop offset=".52" stop-color="#7073d7" stop-opacity=".92" />
            <stop offset=".59" stop-color="#676ad4" stop-opacity=".98" />
            <stop offset=".66" stop-color="#6467d4" />
          </slot>
        </linearGradient>
      </defs>

      <path
        fill-rule="evenodd"
        class="cls-1"
        :fill="`url(#${degId})`"
        :class="colorClass"
        d="M12,18.02c-3.31,0-6-2.69-6-6,0-.82,.17-1.61,.47-2.32,.91-2.15,3.04-3.65,5.53-3.65,1.89,0,3.58,.88,4.69,2.25,.35,.43,.97,.5,1.41,.15,.11-.09,.2-.2,.26-.32,.19-.34,.16-.78-.1-1.11-1.46-1.83-3.72-3-6.25-3-3.32,0-6.16,2.02-7.38,4.9-.41,.96-.63,2.02-.63,3.12,0,.2,.02,.39,.03,.59h0c.31,4.13,3.76,7.39,7.97,7.39,2.53,0,4.78-1.17,6.25-3l-1.56-1.25c-1.1,1.37-2.79,2.25-4.69,2.25Z"
      />
    </svg>
  </div>
</template>

<style lang="scss" scoped>
.loader {
  &--center {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
